export default __webpack_public_path__ + "static/media/logo-ambiente-scienze-NC.77adb390.png";